import { BoardWithPermissionsModel } from "models/BoardWithPermissionsModel";
import { PaginatedList } from "models/PaginatedList";
import { createContext } from "react";
import { BoardsQuery } from "services/BoardsApi";

export interface BoardsContextProps {
  boards: PaginatedList<BoardWithPermissionsModel> | undefined;
  isLoading: boolean;
  error: Error | null;
  query: BoardsQuery;
  setQuery: (query: BoardsQuery) => void;
  reload: () => void;
  resetQuery: () => void;
}

export const BoardsContext = createContext({} as BoardsContextProps);
